import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

import SourceLink from '../../components/SourceLink';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          © House. All rights reserved <SourceLink>Darengot</SourceLink>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
